/* @flow */
// typecheck: ignore file
import React from 'react';
import cx from 'classnames';
import Glyph from 'components/Glyph.jsx';
import Image from 'components/Image.jsx';
import getPropClasses from 'lib/getPropClasses';
import type { GlyphName } from '@remind/r101-glyphs';

import './styles/Avatar.scss';

type AvatarProps = {
  color?: ?'grey' | 'fullGrey' | 'brand',
  size?: ?'xsmall' | 'small' | 'medium',
  colorHex?: ?string,
  className?: ?string,
  image?: ?string,
  glyphName?: ?GlyphName,
  text?: ?string,
  date?: ?Date,
};

function computeColorHexStyles(colorHex?: ?string) {
  if (!colorHex) {
    return {};
  }

  return {
    color: `#${colorHex}`,
    borderColor: `#${colorHex}`,
  };
}

const propsToClasses = {
  color: {
    grey: 'Avatar-grey',
    fullGrey: 'Avatar-fullGrey',
    brand: 'Avatar-brand',
  },
  size: {
    medium: 'Avatar-medium',
    small: 'Avatar-small',
    xsmall: 'Avatar-xsmall',
  },
};

// UNTIL prop-types lint can detect Flow annotation
/* eslint-disable react/prop-types */
export default function Avatar(props: AvatarProps) {
  if (__DEV__ && props.text && props.text.length > 2) {
    console.warn(`user icon text ${props.text} should be 2 characters max`);
  }

  const style = computeColorHexStyles(props.colorHex);
  const { text, glyphName, image, date } = props;

  return (
    <div
      style={style}
      className={cx('Avatar', getPropClasses(props, propsToClasses), props.className)}>
      <AvatarContent
        text={text}
        glyphName={glyphName}
        image={image}
        date={date}
      />
    </div>
  );
}

type AvatarContentProps = {
  image?: ?string,
  glyphName?: ?GlyphName,
  text?: ?string,
  date?: ?Date,
};

const shortMonthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

function AvatarContent(props: AvatarContentProps) {
  if (props.glyphName) {
    return (
      <div className="Avatar-glyphContainer">
        {props.glyphName &&
          <div>
            <Glyph name={props.glyphName} size="large" solo />
          </div>
        }
        {props.text &&
          <div className="Avatar-text">
            {props.text}
          </div>
        }
      </div>
    );
  }

  const date = props.date;
  if (date) {
    return (
      <div className="Avatar-dateContainer">
        <div className="Avatar-dateContainer-month">
          {shortMonthNames[date.getMonth()]}
        </div>
        <div className="Avatar-dateContainer-day">
          {date.getDate()}
        </div>
      </div>
    );
  }

  if (props.text) {
    return <span>{props.text}</span>;
  }

  if (props.image) {
    return <Image className="Avatar-image" src={props.image} />;
  }

  return <span />;
}



// WEBPACK FOOTER //
// ./src/components/Avatar.jsx